import { useState, type ReactNode } from "react";
import { api } from "@/lib/api";
import { useOturum } from "@/lib/oturum";
import { cevir } from "@/lib/dil";
import { Buton, girdi } from "@/components/parcalar";

export interface OlaySatiri { id: string; ts: string; kim: string; olay: string }

/**
 * Olay kaydı satırı; yöneticiye "düzenle" ve "sil" (16.09 kararı, test aşaması). Görünüm çağıran ekranın
 * (children), bileşen yalnız denetimleri ekler. Denetimler bilerek sönük: olağan iş kaydı okumaktır.
 * `salt`: satır donmuş (D-040: iptal edilmiş işin zaman çizelgesi); denetim çizilmez, sunucu da reddeder.
 */
export function OlayDuzenle({ o, onDegisti, salt = false, children }: { o: OlaySatiri; onDegisti: () => void | Promise<void>; salt?: boolean; children: ReactNode }) {
  const { ben } = useOturum();
  const [taslak, setTaslak] = useState<string | null>(null);
  const [hata, setHata] = useState<string | null>(null);
  const dene = async (f: () => Promise<unknown>) => {
    setHata(null);
    try { await f(); setTaslak(null); await onDegisti(); } catch (e) { setHata(e instanceof Error ? e.message : cevir("Error")); }
  };
  if (taslak !== null) {
    return (
      <div className="flex flex-wrap items-center gap-2 py-1">
        <input className={girdi + " min-w-0 flex-1"} value={taslak} onChange={(e) => setTaslak(e.target.value)} autoFocus />
        <Buton kucuk tur="birincil" disabled={!taslak.trim() || taslak === o.olay} onClick={() => dene(() => api.patch(`/olay/${o.id}`, { olay: taslak }))}>{cevir("Save")}</Buton>
        <Buton kucuk onClick={() => setTaslak(null)}>{cevir("Cancel")}</Buton>
        {hata && <span className="text-xs text-bad">{hata}</span>}
      </div>
    );
  }
  return (
    <div className="flex items-start gap-2">
      <div className="min-w-0 flex-1">{children}</div>
      {ben?.yonetici && !salt && (
        <span className="flex shrink-0 gap-2 pt-0.5 text-2xs">
          <button type="button" className="text-ink-3 underline hover:text-ink" onClick={() => setTaslak(o.olay)}>{cevir("edit")}</button>
          <button type="button" className="text-ink-3 underline hover:text-bad" onClick={() => { if (window.confirm(cevir("Delete this log entry? This cannot be undone."))) void dene(() => api.sil(`/olay/${o.id}`)); }}>{cevir("delete")}</button>
        </span>
      )}
      {hata && <span className="text-xs text-bad">{hata}</span>}
    </div>
  );
}
